require('./daterangepicker.jade')
moment = require("moment")
require("bootstrap-daterangepicker")

DateRangePickerDirective = ($filter) ->
  restrict: "A"
  replace: false
  templateUrl: "analysis/period-filter/daterangepicker.jade"
  scope:
    start: '=start'
    end: '=end'
    user_id: '=user'
  link: (scope, elem) ->
    label = localStorage.getItem("#{scope.user_id}_FILTER_PERIOD_SELECTED_LABEL")
    scope.label = if label? then label else $filter('translate')('_ANALYSIS.PERIOD_FILTER.ENTIRE_PERIOD')
    currentYear = (new Date()).getFullYear()

    ranges = {}

    ranges[$filter('translate')('_ANALYSIS.PERIOD_FILTER.ENTIRE_PERIOD')] = [
      moment().subtract 10, 'years'
      moment().endOf('year')
    ]

    ranges[" #{currentYear}"] = [
      moment().startOf('year')
      moment().endOf('year')
    ]

    ranges[" #{currentYear - 1}"] = [
      moment().subtract(1, 'years').startOf('year')
      moment().subtract(1, 'years').endOf('year')
    ]

    ranges[$filter('translate')('_ANALYSIS.PERIOD_FILTER.LAST_3_MONTHS')] = [
      moment().subtract 3, "months"
      moment()
    ]

    ranges[$filter('translate')('_ANALYSIS.PERIOD_FILTER.LAST_6_MONTHS')] = [
      moment().subtract 6, "months"
      moment()
    ]


    elem.daterangepicker
      format: "YYYY-MM-DD"
      startDate: scope.start
      endDate: scope.end
      ranges: ranges
      applyButtonClasses: 'btn-success'
      showDropdowns: true
      minYear: 2008
      maxYear: currentYear + 1
      locale:
        applyLabel: $filter('translate')('_ANALYSIS.PERIOD_FILTER.APPLY_LABEL')
        cancelLabel: $filter('translate')('_ANALYSIS.PERIOD_FILTER.CANCEL_LABEL')
        customRangeLabel: $filter('translate')('_ANALYSIS.PERIOD_FILTER.CUSTOM_RANGE_LABEL')
      ,
      (start, end, label) ->
        scope.$apply ->
          scope.start = start
          scope.end = end
          scope.label = label
          localStorage.setItem "#{scope.user_id}_FILTER_PERIOD_SELECTED_LABEL", label

DateRangePickerDirective.$inject = [
  "$filter"
]

module.exports = DateRangePickerDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/analysis/period-filter/daterangepicker-directive.coffee